import type { ProcessStep } from '../types';

export interface ApplicationStage {
  label: string;
  statuses: string[];
  color: string;
  softColor: string;
}

export const APPLICATION_STAGES: ApplicationStage[] = [
  {
    label: 'Matched',
    statuses: ['Found', 'Matched'],
    color: '#0a8bc2',
    softColor: '#c6ebfa',
  },
  {
    label: 'Applied',
    statuses: ['Applied'],
    color: '#64748b',
    softColor: '#e2e8f0',
  },
  {
    label: 'Interview',
    color: '#a78bfa',
    softColor: '#ede9fe',
    statuses: [
      'Recruiter Screen',
      'Phone Screen',
      'Hiring Manager Screen',
      'Interview',
      'First Interview',
      'Second Interview',
      'Hiring Manager Interview',
      'Team Interview',
      'Panel Interview',
      'Final Interview',
      'Technical Interview',
      'Technical Assessment',
      'Case Study',
      'Portfolio Review',
      'Assessment',
    ],
  },
  {
    label: 'Offer',
    statuses: ['Offer Received', 'Reference Check', 'Background Check', 'Negotiation'],
    color: '#10b981',
    softColor: '#d1fae5',
  },
  {
    label: 'Hired',
    statuses: ['Accepted'],
    color: '#16a34a',
    softColor: '#dcfce7',
  },
];

export const CLOSED_APPLICATION_STATUSES = ['Rejected', 'Not selected', 'Withdrawn'];

export const getApplicationStageIndex = (
  currentStatus: string,
  steps: Pick<ProcessStep, 'process_type'>[]
): number => {
  const statuses = [currentStatus, ...steps.map((step) => step.process_type)].filter(Boolean);
  const reachedIndexes = statuses
    .map((status) => APPLICATION_STAGES.findIndex((stage) => stage.statuses.includes(status)))
    .filter((index) => index >= 0);

  return reachedIndexes.length ? Math.max(...reachedIndexes) : 0;
};
